import actions from './constants';

export const fetchClauseCounts = (category, code, queryUUID, clauseUUID, cascade) => ({
  type: actions.FETCH_CLAUSE_COUNTS,
  category,
  code,
  queryUUID,
  clauseUUID,
  cascade,
});

export const showClauseCounts = (category, code, total, totalFiltered, entities, queryUUID, clauseUUID) => ({
  type: actions.SHOW_CLAUSE_COUNTS,
  category,
  code,
  total,
  totalFiltered,
  entities,
  queryUUID,
  clauseUUID,
});

export const showClauseCountsError = (category, code, error, queryUUID, clauseUUID) => ({
  type: actions.SHOW_CLAUSE_COUNTS_ERROR,
  category,
  code,
  error,
  queryUUID,
  clauseUUID,
});

export const showClauseCountsCancelled = (category, code, queryUUID, clauseUUID) => ({
  type: actions.SHOW_CLAUSE_COUNTS_CANCELLED,
  category,
  code,
  queryUUID,
  clauseUUID,
});

export const showClausesCounts = (category, code, total, totalFiltered, entities, queryUUID, dictionaryCode) => ({
  type: actions.SHOW_CLAUSES_COUNTS,
  category,
  code,
  total,
  totalFiltered,
  entities,
  queryUUID,
  dictionaryCode,
});

export const showClausesCountsError = (category, code, error, queryUUID, dictionaryCode) => ({
  type: actions.SHOW_CLAUSES_COUNTS_ERROR,
  category,
  code,
  error,
  queryUUID,
  dictionaryCode,
});

export const showClausesCountsCancelled = (category, code, queryUUID, dictionaryCode) => ({
  type: actions.SHOW_CLAUSES_COUNTS_CANCELLED,
  category,
  code,
  queryUUID,
  dictionaryCode,
});
